<template>
  <div id="landingPageHolder">
      <div class="contentHolder">
          <img class="logo" src="../assets/fisher-insta-meetings.svg" />
          <h2 class="userName"
              v-if="linkInfo.people">
              Hi, {{linkInfo.people.firstName}} {{linkInfo.people.lastName}}
          </h2>
          <template v-if="error">
              <template v-if="error.response.status === 400">
                  <h4>
                      The meeting you are looking for cannot be found.<br />
                      Please contact your core group leader for more information.
                  </h4>
              </template>
              <template v-if="error.response.status === 500">
                  <h4>
                      Oops! Something went wrong!<br />
                      Help us improve your experience by sending an error report
                  </h4>
              </template>
          </template>
          <template v-if="meetingPlatform === 'zoom' && linkInfo.isHost === false">
              <template v-if="meetingInfo.meetingStartTime && checkTime() < 1800 && checkTime() > -7000">
                  <template v-if="meetingStatus === 2 && meetingLink !== ''">
                      <button class="meetingBtn" @click="goTo(meetingLink)">
                          <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                          <span>Meeting is ready</span>
                      </button>
                  </template>
                  <template v-else>
                      <button class="meetingBtn inActive">
                          <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                          <span>Waiting on host to start a meeting</span>
                      </button>
                  </template>
              </template>
              <template v-else-if="meetingInfo.meetingStartTime && checkTime() < -7500">
                  <h4>Sorry, your meeting has ended.</h4>
              </template>
              <template v-else>
                  <h4>Meeting start link will be active 30min before meeting:</h4>
                  <button class="meetingBtn inActive">
                      <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                      <span>STARTS {{ moment.utc(meetingInfo.meetingStartTime).local().format('MMM Do YYYY, h:mm a') }}</span>
                  </button>
              </template>
          </template>

          <template v-else-if="meetingPlatform === 'zoom' && linkInfo.isHost === true">
              <template v-if="meetingInfo.meetingStartTime && checkTime() < 1800 &&  checkTime() > -7000">
                  <template v-if="meetingStatus === 0">
                      <h4>You can start your meeting now</h4>
                      <button class="meetingBtn meetingStart" @click="startMeeting()">
                          <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                          <span>Start meeting</span>
                      </button>
                  </template>
                  <template v-if="meetingStatus === 1">
                      <h4>You can start your meeting now</h4>
                      <button class="meetingBtn meetingWait" @click="startMeeting()">Creating meeting...</button>
                  </template>
                  <template v-if="meetingStatus === 2 && meetingLinkHost !== ''">
                      <button class="meetingBtn" @click="goTo(meetingLinkHost)">
                          <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                          <span>Meeting is ready - STARTS {{ moment.utc(meetingInfo.meetingStartTime).local().format('MMM Do YYYY, h:mm a') }}</span>
                      </button>
                  </template>
                  <template v-else-if="meetingStatus === 2 && meetingLink !== ''">
                      <button class="meetingBtn" @click="goTo(meetingLink)">
                          <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                          <span>Meeting is ready - STARTS {{ moment.utc(meetingInfo.meetingStartTime).local().format('MMM Do YYYY, h:mm a') }}</span>
                      </button>
                  </template>
              </template>
              <template v-else-if="meetingInfo.meetingStartTime && checkTime() < -7500">
                  <h4>Sorry, your meeting has ended.</h4>
              </template>
              <template v-else>
                  <h4>Meeting start link will be active 30min before meeting:</h4>
                  <button class="meetingBtn inActive">
                      <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                      <span>STARTS {{ moment.utc(meetingInfo.meetingStartTime).local().format('MMM Do YYYY, h:mm a') }}</span>
                  </button>
              </template>
          </template>

          <template v-else-if="meetingPlatform !== 'zoom'">
              <template v-if="meetingInfo.meetingStartTime && checkTime() < 1800 &&  checkTime() > 0">
                  <h4>Meeting start link will be active 30min before meeting:</h4>
                  <button class="meetingBtn inActive">
                      <span class="meetingName"><img class="icon" src="../assets/icon-video-meeting-white.svg" /> {{meetingInfo.title}}</span>
                      <span>STARTS {{ moment.utc(meetingInfo.meetingStartTime).local().format('MMM Do YYYY, h:mm a') }}</span>
                  </button>
              </template>
              <template v-else-if="meetingInfo.meetingStartTime && checkTime() < -7500">
                  <h4>Sorry, your meeting has ended.</h4>
              </template>
          </template>
      </div>
    <div class="landingPageFooter">
      <div class="left">
        <button @click="goTo(appConfig.helpBtnLink)">{{appConfig.helpBtnName}}</button>
      </div>
      <div class="right">
        <a target="_blank" :href="appConfig.landingpageLink1">{{appConfig.landingpageLinkName1}}</a>
        <a target="_blank" :href="appConfig.landingpageLink2">{{appConfig.landingpageLinkName2}}</a>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable no-debugger */
import { mapGetters, mapMutations, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import aplicationConfig from '../aplicationConfig.json'

export default {
  name: "LandingPage",
  components: {},
  data() {
    return {
      state: {},
      access: false,
      error: false,
      linkInfo: {},
      meetingInfo: {},
      meetingLink: "",
      meetingLinkHost: "",
      meetingStatus: "",
      meetingPlatform: "zoom",
      appConfig: aplicationConfig,
    };
  },

  computed: mapGetters(["meetingModalOpen", "getMeetingModalType"]),
  methods: {
    ...mapMutations(["toggleModal"]),
    // ...mapActions(["autoAttendance"]),
    startMeeting() {
      const data = {
        MeetingId: this.linkInfo.meetingId,
        PersonId: this.linkInfo.personID
      };
      axios
        .post(`/api/public/meeting/start`, data)
        .then(response => {
            axios.get(`/api/public/meeting/status/${this.linkInfo.meetingId}`)
                .then(statusResponse => {
                    this.meetingStatus = statusResponse.data;
                    this.checkStatus();
                    this.meetingLinkHost = response.data.meetingLink;
                    if (this.meetingPlatform === 'zoom' && this.linkInfo.isHost === true && this.meetingStatus === 2 && this.meetingLinkHost !== "") {
                        this.goTo(this.meetingLinkHost);
                    }
                })
                .catch(function (ex) {
                    console.error(ex);
                });
        })
        .catch(function(ex) {
          console.error(ex);
        });
    },
    goTo(link) {
      window.open(link, "_blank");
    },
    checkTime() {
      return (
        moment.utc(this.meetingInfo.meetingStartTime).local().format("X") -
        moment().format("X")
      );
    },
    getLinkInfo() {
      return axios.get(
        `/api/public/landing?code=${encodeURIComponent(this.$route.query.code)}`
      );
    },
    getMeetingInfo() {
      return axios
        // .get(`/api/public/meeting/${this.linkInfo.meetingId}`)
        .get(`/api/public/landing?code=${encodeURIComponent(this.$route.query.code)}`)
        .then(response => {
          this.meetingInfo = response.data.meetingInfo;
          this.access = true;
          this.linkInfo = response.data;
          this.checkStatus();
        })
        .catch(function(ex) {
          console.error(ex);
        });
    },
    getStatus() {
        console.log(this.linkInfo.meetingId);
      if(this.linkInfo.meetingId){
      axios
        .get(`/api/public/meeting/status/${this.linkInfo.meetingId}`)
          .then(response => {
          this.meetingStatus = response.data;
          if (response.data === 1 || response.data === 2) {
            this.getMeetingLink();
          }
        })
        .catch(function(ex) {
          console.error(ex);
        });
      }
    },
    getMeetingLink() {
      axios
        .get(`/api/public/meeting/link/${this.linkInfo.meetingId}`)
        .then(response => {
          console.log(response.data);
          this.meetingLink = response.data;
        })
        .catch(function(ex) {
          console.error(ex);
        });
    },
    getMeetingPlatform() {
      axios
        .get(`/api/public/meeting/platform/${this.linkInfo.meetingId}`)
        .then(response => {
          console.log(response.data);
          this.meetingPlatform = response.data;
        })
        .catch(function(ex) {
          console.error(ex);
        });
    },
    checkStatus() {
      if (this.checkTime() < 1800 && this.checkTime() > -7200) {
        if (this.meetingLink === "") {
            this.getStatus();
          setInterval(() => {
            this.getStatus();
          }, 50000);
        }
      }
    }
  },
  created() {
    fetch("/AplicationConfig.json")
    .then(r => r.json())
    .then(json => {
      console.log(json);
      this.levels=json;
    });
    if (this.$route.query.code) {
        this.getMeetingInfo()
            .then(response => {
            })
            .catch((ex) => {
                this.error = ex;
                console.error(ex);
            });
    }
  }
};
</script>

<style lang="scss" scoped src="@/styles/style-landing.scss">
</style>
